module.exports = __webpack_public_path__ + "img/logoText4.bedb1e7c.png";